import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles-v2/Noticias.css';

const Noticias = () => {
    const { t } = useTranslation();
    const sectionRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    // Get up to 4 news items
    const rawItems = t('news.items', { returnObjects: true });
    // Make sure it's an array and limit to 4
    const newsItems = Array.isArray(rawItems) ? rawItems.slice(0, 4) : [];

    const renderText = (text) => {
        const lines = text.split('\n');
        const elements = [];
        let listItems = [];

        lines.forEach((line, i) => {
            if (line.trim().startsWith('-')) {
                // Si la línea empieza con un guión, la agregamos a los items de la lista
                const textLi = line.trim().substring(1).trim();
                listItems.push(<li key={`li-${i}`}>{textLi}</li>);
            } else {
                // Si veníamos juntando items de una lista, cerramos la lista y la agregamos
                if (listItems.length > 0) {
                    elements.push(<ul key={`ul-${i}`} className="noticias-ul">{listItems}</ul>);
                    listItems = []; 
                }
                
                // Agregamos la línea normal de texto
                elements.push(
                    <React.Fragment key={`text-${i}`}>
                        {line}
                        <br />
                    </React.Fragment>
                );
            }
        });

        // Si quedó una lista abierta al final, la agregamos
        if (listItems.length > 0) {
            elements.push(<ul key="ul-end" className="noticias-ul">{listItems}</ul>);
        }

        return elements;
    };

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        const node = sectionRef.current;
        if (node) {
            observer.observe(node);
        }

        return () => {
            if (node) observer.unobserve(node);
        };
    }, []);

    return (
        <section id="noticias" className={`noticias-section fade-in-section ${isVisible ? 'is-visible' : ''}`} ref={sectionRef}>
            <div className="noticias-container">
                <h2 className="noticias-title">{t('news.title')}</h2>
                
                <div className="noticias-list">
                    {newsItems.map((item, index) => (
                        <div key={index} className="noticia-card">
                            <div className="noticia-content">
                                <div className="noticia-text">
                                    {renderText(item.text)}
                                </div>
                            </div>
                            <div className="noticia-video-container">
                                <video 
                                    className="noticia-video" 
                                    controls 
                                    autoPlay 
                                    muted 
                                    loop 
                                    playsInline
                                >
                                    <source src={`/videos-noticias/${item.video}`} type="video/mp4" />
                                    Tu navegador no soporta el tag de video.
                                </video>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Noticias;
